import { Injectable, Injector, OnDestroy, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { SessionService } from '@src/app/shared/services/session.service';

@Injectable()
export class AppTitleStrategy extends TitleStrategy implements OnDestroy {
  private readonly title = inject(Title);
  private readonly injector = inject(Injector);
  private readonly destroy$ = new Subject<void>();

  private readonly appName = 'Retail Insights';

  private latestRouteTitle?: string;
  private hasSubscribedToCompanyData = false;

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.latestRouteTitle = this.buildTitle(snapshot);

    const sessionService = this.injector.get(SessionService);
    const companyName = sessionService.getCurrentCompanyDetails()?.name ?? undefined;

    this.setBrowserTitle(this.latestRouteTitle, companyName);
    this.subscribeToCompanyData(sessionService);
  }

  private subscribeToCompanyData(sessionService: SessionService): void {
    if (this.hasSubscribedToCompanyData) {
      return;
    }

    this.hasSubscribedToCompanyData = true;

    sessionService.currentCompanyData$
      .pipe(takeUntil(this.destroy$))
      .subscribe(company => {
        this.setBrowserTitle(this.latestRouteTitle, company?.name ?? undefined);
      });
  }

  private setBrowserTitle(routeTitle?: string, companyName?: string): void {
    const baseTitle = routeTitle ? `${routeTitle} | ${this.appName}` : this.appName;
    const browserTitle = companyName ? `${baseTitle}: ${companyName}` : baseTitle;
    this.title.setTitle(browserTitle);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
